<template>
  <v-app :style="{ backgroundColor: backgroundColorHex }">
    <unsupported-browser-dialog
      v-if="!isSupportedBrowser && !acknowledgedUnsupportedBrowser"
      @acknowledge-unsupported-browser="acknowledgeUnsupportedBrowser"
    />
    <inactivity-warning-dialog />
    <router-view />
    <app-snackbar-queue />
  </v-app>
</template>

<script>
import Vue from 'vue'
import _ from 'lodash'
import { MyActiveOrganization } from '@/helpers/my-account-helper'
import { MERGE_ORGANIZATIONS } from '@/store/mutation-types'
import UnsupportedBrowserDialog from '@/components/unsupported-browser/UnsupportedBrowserDialog'
import { isSupportedBrowser } from '@/helpers/browser-validation-helper'
import InactivityWarningDialog from '@/components/common/InactivityWarningDialog'
import { mapState } from 'vuex'
import AppSnackbarQueue from '@/components/common/AppSnackbarQueue'

export default {
  components: {
    AppSnackbarQueue,
    UnsupportedBrowserDialog,
    InactivityWarningDialog
  },
  data() {
    return {
      acknowledgedUnsupportedBrowser: false
    }
  },
  computed: {
    ...mapState({
      backgroundColor: state => state.layout.backgroundColor
    }),
    backgroundColorHex() {
      return _.get(this.$vuetify.theme.themes.light, this.backgroundColor, 'white')
    },
    isSupportedBrowser() {
      return isSupportedBrowser()
    }
  },
  created() {
    window.addEventListener('beforeunload', this.beforeunloadHandler)
    window.addEventListener('unload', this.unloadHandler)
  },
  mounted() {
    this.$store.commit(MERGE_ORGANIZATIONS, {
      [MyActiveOrganization.id]: MyActiveOrganization
    })
    this.$store.dispatch('GET_TRIAL_NOTIFICATION_PREFERENCES')
  },
  methods: {
    unloadHandler: function hander() {
      // This implementation is explicitly intended to be simple and synchronous
      // to improve the likelyhood this request makes it to the backend.
      if (_.keys(this.$store.state.upload.currentUploads).length !== 0) {
        const fileUploadIds = _.keys(this.$store.state.upload.currentUploads)
        const client = new XMLHttpRequest()
        client.open('POST', `${this.VUE_APP_VIPER_API_BASE_URL}/upload/abort`, true)
        client.setRequestHeader('Content-Type', 'application/json')
        client.setRequestHeader('Authorization', `Bearer ${Vue.prototype.$keycloak.token}`)
        client.send(JSON.stringify(fileUploadIds))
      }
    },
    beforeunloadHandler: function handler(event) {
      // Show the user a dialog prompt if there are uploads in progress
      if (_.keys(this.$store.state.upload.currentUploads).length !== 0) {
        event.returnValue = `In progress uploads`
      }
    },
    acknowledgeUnsupportedBrowser() {
      this.acknowledgedUnsupportedBrowser = true
    }
  }
}
</script>

<style lang="scss">
html {
  height: 100%;
}

body {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
}

.z1 {
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.26) !important;
}

.viper-outline-input {
  .v-input__slot {
    min-height: 45px !important;
    border-width: 1px !important;

    .v-input__append-inner {
      margin-top: 10px;
    }

    .v-text-field__slot {
      input,
      textarea {
        margin-top: 5px;
      }
    }
  }
}

.theme--light.v-application {
  background-color: var(--v-white-base);
}

.theme--light.v-card > .v-card__text {
  color: rgba(0, 0, 0, 0.87);
}

.toolbar-no-padding.v-toolbar > .v-toolbar__content {
  padding: 0 !important;
}

.viper-link {
  text-decoration: none;
}

.viper-link:hover {
  text-decoration: underline;
}

.v-btn {
  text-transform: none !important;
}

* {
  letter-spacing: normal;
}

.dark-headers {
  th:first-child {
    border-top-left-radius: 8px;
  }
  th:last-child {
    border-top-right-radius: 8px;
  }
  th[role='columnheader'] {
    color: white !important;
    background-color: var(--v-dark-base);
    i {
      color: white !important;
    }
  }
}

.v-data-table:not(.show-hover) tr:hover {
  background-color: transparent !important;
}

.top-bar {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 200 !important;
  background-color: #1d2529 !important;
  box-shadow: none !important;
}

.v-treeview-node__children {
  background-color: #f8f8f8;
  border-top: solid 1px rgba(0, 0, 0, 0.12);
  border-bottom: solid 1px rgba(0, 0, 0, 0.12);
}

.outlined {
  border: solid 1px rgba(0, 0, 0, 0.12);
}
</style>
